const CollapsibleContent = {
    init: (element: HTMLElement) => {
        CollapsibleContent.initAlpineData();
    },
    initAlpineData: () => {
        document.addEventListener('alpine:init', () => {
            Alpine.data('collapsibleContent', () => ({
                contentOpen: false,
                buttonFull: false,
                toggleCloseContent: null,
                containerAttributes: {},
                toggleAttributes: {
                    [':class']() {
                        const dataClass = this.$el.getAttribute('data-class');
                        return {
                            [dataClass ? `${dataClass}--active` : 'toggle-text-button--active']: this.buttonFull,
                        };
                    },
                    [':aria-expanded']() {
                        return this.contentOpen;
                    },
                    ['@click']() {
                        this.handleToggleClick();
                    },
                    ['@keydown.escape.window.prevent.stop']() {
                        this.closeContent();
                    },
                    ['x-text']() {
                        if (this.$el.hasAttribute('data-open-text')) {
                            const text = this.contentOpen ? this.$el.getAttribute('data-open-text') : this.$el.getAttribute('data-close-text');
                            this.$el.textContent = text;
                            return text;
                        }
                        return this.$el.textContent;
                    },
                },
                contentAttributes: {
                    ['x-show']() {
                        return this.contentOpen;
                    },
                    ['x-collapse']: true,
                    ['x-collapse.duration.150ms']: true,
                    [':class']() {
                        return {
                            'js-initialized': true,
                        };
                    },
                    ['@click.outside']() {
                        this.closeContent();
                    },
                    [':aria-hidden']() {
                        return !this.contentOpen;
                    },
                },

                /** Functions  */

                handleToggleClick() {
                    if (this.contentOpen) {
                        this.closeContent();
                    } else {
                        this.openContent();
                    }
                },
                openContent() {
                    if (!this.contentOpen) {
                        this.$nextTick(() => {
                            this.buttonFull = true;
                            this.contentOpen = true;
                        });
                    }
                },

                closeContent() {
                    if (this.contentOpen) {
                        this.contentOpen = false;
                        setTimeout(() => {
                            this.buttonFull = false;
                        }, 150);
                    }
                },
            }));
        });
    },
};

export default CollapsibleContent;
